import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../App.css';
import { FaPhoneAlt, FaInstagram, FaFacebookF, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';

function Footer() {
    return (
        <Row>
            <Col lg={12}>
                <h5><i>Contact me using below options</i></h5>
            </Col>
            <Col><a href="tel:+91 8248612657"><FaPhoneAlt style={{ fontSize: "20px", color: "#6883BC" }} /></a></Col>
            <Col><a href="mailto:priyadharshinikantharajclinpsy@gmail.com"><FaEnvelope style={{ fontSize: "20px", color: "#6883BC" }} /></a></Col>
            <Col><a href="https://www.instagram.com/headshrinker_ind/?igshid=YmMyMTA2M2Y%3D"><FaInstagram style={{ fontSize: "20px", color: "#6883BC" }} /></a></Col>
            <Col><a href="https://www.facebook.com/profile.php?id=100084250914032"><FaFacebookF style={{ fontSize: "20px", color: "#6883BC" }} /></a></Col>
            <Col><a href="https://www.linkedin.com/in/head-shrinker-46b9b4248"><FaLinkedinIn style={{ fontSize: "20px", color: "#6883BC" }} /></a></Col>
        </Row>
    );
}

export default Footer;